module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "resetPasswordModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "box k6-modal-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('h2', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.resetPassword.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("pages.resetPassword.description")))])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control text-center rounded-action",
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": _vm.$t('pages.register.email'),
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "k6-primary-btn rounded-action",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitData($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.resetPassword.resetMsg')))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "height": "200px",
      "width": "350px"
    },
    attrs: {
      "src": require("../../assets/reset_password.svg")
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c5fa00b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c5fa00b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/authentication/ResetPassword.vue
// module id = 1405
// module chunks = 1